<!-- xPosition defaults to 'after' (correct for LTR side rail). Revisit with Directionality if RTL is added. -->
<mat-menu #menu="matMenu" class="cipo cipo-menu menu-flyout" [overlapTrigger]="true" [attr.aria-labelledby]="headerId">
    <div class="menu-flyout__header">
        <itv-module-icon [iconid]="iconId() ? iconId() : 6" [color]="color()" />
        <span class="menu-flyout__header-label" [id]="headerId">{{ label() }}</span>
    </div>
    @for (item of visibleItems(); track $index) {
        @if (isMenuFolder(item)) {
            <button
                mat-menu-item
                #flyoutMenuItem="matMenuItem"
                class="menu-flyout__item"
                appMenuFlyoutFit
                [matMenuTriggerFor]="childFlyout.menu()"
                [attr.aria-label]="item.name"
                data-testid="menu-sidebar-flyout-folder">
                <itv-module-icon [iconid]="item.iconId ? item.iconId : 6" [color]="item.color" />
                <span class="menu-flyout__item-label">{{ item.name }}</span>
            </button>
            <app-menu-flyout
                #childFlyout
                [items]="item.children"
                [label]="item.name"
                [iconId]="item.iconId"
                [color]="item.color"
                [activeId]="activeId()"
                (itemClick)="itemClick.emit($event)" />
        } @else {
            <button
                mat-menu-item
                #flyoutMenuItem="matMenuItem"
                class="menu-flyout__item"
                [class.menu-flyout__item--active]="item.id === activeId()"
                (click)="itemClick.emit(item)"
                [attr.aria-label]="item.name"
                data-testid="menu-sidebar-flyout-item">
                @if (item.id === activeId()) {
                    <span class="menu-flyout__active-bar" aria-hidden="true"></span>
                }
                <itv-module-icon [iconid]="item.iconId" [color]="item.color" />
                <span class="menu-flyout__item-label">{{ item.name }}</span>
            </button>
        }
    }
</mat-menu>
